import { o_util } from "../../common/namespaces";
import { deprecated } from "../../common/logger";
import { assignNamespace } from "../../common/namespace-utils";

/**
 *
 */
export function getScrollbarWidth(): number {
  const scrollDiv = document.createElement("div");
  let scrollbarWidth = 0;

  if (document.body.clientWidth < window.innerWidth) {
    scrollDiv.className = "p_scrollbarMeasure";

    document.body.appendChild(scrollDiv);
    scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
  }

  return scrollbarWidth;
}

/**
 *
 */
export const findInUserAgent = (needle: string): boolean =>
  navigator.userAgent.toLowerCase().indexOf(needle) !== -1;

/**
 *
 */
export const getStyle = <T extends Element>(elem: T, styleProp: string): string => {
  return window.getComputedStyle(elem, null).getPropertyValue(styleProp);
};

assignNamespace(o_util, "browser", {
  findInUserAgent,
  getScrollbarWidth: deprecated(
    getScrollbarWidth,
    "browser",
    "getScrollbarWidth",
    "use viewport/getScrollbarWidth instead",
  ),
  getStyle: deprecated(getStyle, "browser", "getStyle", "use native getComputedStyle instead"),
});
